import { memo } from 'react'
import isEqual from 'react-fast-compare'
import styled from 'styled-components'

import { decodeHtml } from '@nx/decode-html'
import { Label } from '@nx/fire/typography'
import { buildPriceString } from '@nx/helpers'
import { getTranslate } from '@nx/translations'

import translate from './MaxBid.translate.json'

const { text } = getTranslate(translate)

export const MaxBid = memo(
  ({ currencySymbol, price, ...props }: MaxBidProps) => (
    <StyledMaxBidLabel $level="S" {...props}>
      {text('max', {
        price: buildPriceString({
          currencySymbol: decodeHtml(currencySymbol),
          lowPrice: price,
        }),
      })}
    </StyledMaxBidLabel>
  ),
  isEqual
)

export const StyledMaxBidLabel = styled(Label)`
  /* Empty for override styles */
`

export interface MaxBidProps {
  currencySymbol: string
  price: number
}
